module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-02-a5b5236f392601fa5f265a61c1e11ba1.png";